"use client";

import React from "react";
import { HeaderSection } from "@/components/shared/header-section";
import { PageContainer } from "@/components/shared/page-container";
import { useQuery } from "@apollo/client";
import { DataTable } from "../../components/shared/data-table/data-table";
import { columns } from "./members-table/columns";
import { User } from "./types";
import { DataTableToolbar } from "../../components/shared/data-table/data-table-toolbar";
import { GET_USERS } from "./membersQueries";
import { Button } from "@/components/ui/button";
import MemberForm from "./components/MemberForm";
import useOpenDrawer from "@/hooks/useOpenDrawer";

export default function Members() {
  const { data: { findManyUser: users } = {} } = useQuery(GET_USERS);
  const openMemberForm = useOpenDrawer(MemberForm);

  return (
    <PageContainer>
      <div className="flex justify-between items-center">
        <HeaderSection
          title="Members"
          subtitle="A list of existing members and their roles."
        />
        <Button onClick={openMemberForm}>Create New +</Button>
      </div>
      <DataTable<User, any>
        data={users ?? []}
        columns={columns(openMemberForm)}
        defaultPageSize={20}
        rowCount={users?.length}
        toolbar={(table: any) => (
          <DataTableToolbar
            table={table}
            config={{
              search: {
                placeholder: "Filter members...",
                accessor: "email",
              },
              columns: [
                {
                  title: "Role",
                  accessor: "role",
                  options: [
                    {
                      label: "ADMIN",
                      value: "ADMIN",
                    },
                    {
                      label: "ACCOUNT_MANAGER",
                      value: "ACCOUNT_MANAGER",
                    },
                  ],
                },
              ],
            }}
          />
        )}
      />
    </PageContainer>
  );
}
